import $ from "jquery";

$(document).ready(function () {
    // prevent non-numeric input
    // we only want five-digit zip codes, so anything that's not a numeral can stay out
    $('.zip-check input').on('keypress', function (e) {
        var allowedChars = '0123456789';
        if (allowedChars.indexOf(e.key) == -1)
            e.preventDefault();
    });

    $('.zip-check form').on('submit', function (e) {
        let formAllowed = $(this).data('allowed');
        let inputZip = parseInt($('input', this).val()); // normally don't like to treat zip codes as ints, but it works since we're restricted to five-digit
        let isInputValid = formAllowed.includes(inputZip);
        if (!isInputValid) {
            e.preventDefault();
            $(this).closest('form').next('.reveal-overlay').addClass('open');
            $('html').addClass('is-reveal-open');
        }
    });

    $('.zip-check .reveal-overlay, .zip-check .close-reveal-modal').on('click', function () {
        $(this).closest('.reveal-overlay').removeClass('open');
        $('html').removeClass('is-reveal-open');
    });
    $('.zip-check .reveal').on('click', function (e) {
        e.stopPropagation();
    });
});